import { StructureDocumentType } from "@ac-expo/api-types";
import { FileType } from "@prisma/client";
import { DocumentCard } from "./DocumentCard";

export function DocumentsPanel({
  documents,
  getFileUrl,
}: {
  getFileUrl: (key?: string, type?: FileType, width?: number) => string;
  documents?: StructureDocumentType[];
}) {
  return (
    <div className="size-full overflow-y-auto grid grid-cols-[repeat(auto-fill,minmax(340px,1fr))] gap-6">
      {(documents || []).map((document: StructureDocumentType) => (
        <DocumentCard
          key={document.id}
          document={document}
          getFileUrl={getFileUrl}
        />
      ))}
    </div>
  );
}

export default DocumentsPanel;
